import api from "@/api";

import deepClone from "@/utils/deep-clone";

const state = {
    results: {
        errors: [],
        count: 0,
    },
};

const getters = {
    results(state) {
        return deepClone(state?.results ?? {});
    },
};

const actions = {
    upload({ commit }, { payload: { file } }) {
        const formData = new FormData();
        formData.append("file", file);

        return api.post("/api/uploads/goals", formData).then(res => {
            const results = res?.data ?? {};

            commit("updateResults", { results });

            return results;
        });
    },
};

const mutations = {
    updateResults(state, { results }) {
        state.results = { ...results };
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
